import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  FiArrowRight, FiCheck, FiMessageCircle, FiPhone, FiVideo, FiSettings
} from 'react-icons/fi';
import { FaCar } from 'react-icons/fa';
import logo from '../../Images/logo.png';
import styles from './SolutionsPage.module.css';

const SolutionsPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={styles.container}>
      {/* Ambient glows */}
      <div className={styles.ambientGlows}>
        <div className={styles.glow1}></div>
        <div className={styles.glow2}></div>
        <div className={styles.glow3}></div>
      </div>

      {/* 🟦 1. HEADER / NAVIGATION */}
      <header className={styles.header} style={{ flex: "none" }}>
        <div className={styles.headerInner}>
          <div className={styles.logoArea} onClick={() => navigate('/')}>
            <img src={logo} alt="SaleSense Logo" className={styles.logoImg} />
            <span className={styles.logoText}>Sailsense <span className={styles.logoCyan}>AI</span></span>
          </div>
          <nav className={styles.navLinks}>
            <a href="/" onClick={(e) => { e.preventDefault(); navigate('/'); }}>Home</a>
            <a href="/ai-agents" onClick={(e) => { e.preventDefault(); navigate('/ai-agents'); }}>AI Agents</a>
            <a href="/platform" onClick={(e) => { e.preventDefault(); navigate('/platform'); }}>Platform</a>
            <a href="/sales-operations" onClick={(e) => { e.preventDefault(); navigate('/sales-operations'); }}>Sales Operations</a>
            <a href="/solutions" className={styles.activeLink} onClick={(e) => { e.preventDefault(); }}>Solutions</a>
            <a href="/pricing" onClick={(e) => { e.preventDefault(); navigate('/pricing'); }}>Pricing</a>
            <a href="/contact" onClick={(e) => { e.preventDefault(); navigate('/contact'); }}>Contact</a>
          </nav>
          <div className={styles.headerActions}>
            <button className={styles.trialBtn} onClick={() => navigate('/login')}>
              login <FiArrowRight />
            </button>
          </div>
        </div>
      </header>

      {/* Grid line overlay */}
      <div className={styles.gridOverlay}></div>

      {/* 🟦 2. SOLUTIONS INTRO */}
      <section className={styles.sectionBlock}>
        <div className={styles.sectionCenter}>
          <div className={styles.badgeCyan}>
            Solutions
          </div>
          <h1 className={styles.sectionCenterTitle}>
            AI Solutions Built For <span className={styles.cyanTitle}>Automotive Dealerships</span>
          </h1>
          <p className={styles.sectionSubtitle}>
            Sailsense adapts its AI agents and automation workflows specifically for the automotive dealership ecosystem.
          </p>
        </div>

        <div className={styles.solutionsGrid}>
          {/* Automotive */}
          <div className={styles.opsCard}>
            <div className={styles.opsCardHeader}>
              <div className={styles.opsIconBox}>
                <FaCar />
              </div>
              <h4 className={styles.opsTitle}>
                Automotive
              </h4>
            </div>
            <p className={styles.opsDesc}>
              For dealerships, showrooms, OEM networks, and automotive groups.
            </p>
            <ul className={styles.opsList}>
              <li><span className={styles.cyanSquareBullet}></span> Lead capture</li>
              <li><span className={styles.cyanSquareBullet}></span> Test drive booking</li>
              <li><span className={styles.cyanSquareBullet}></span> Vehicle recommendations</li>
              <li><span className={styles.cyanSquareBullet}></span> Follow-up automation</li>
              <li><span className={styles.cyanSquareBullet}></span> Financing assistance</li>
            </ul>
          </div>
        </div>
      </section>

      {/* 🟦 3. TAILOR WORKFLOW CTA */}
      <section className={styles.sectionBlock} style={{ borderTop: "1px solid rgba(255, 255, 255, 0.05)", paddingBottom: "6rem" }}>
        <div className={styles.tailorCtaBox}>
          <div className={styles.badgeCyan}>
            Custom Integration
          </div>
          <h2 className={styles.tailorCtaHeading}>
            We can customize an <span className={styles.cyanTitle}>AI workflow</span> for your dealership.
          </h2>
          <div className={styles.tailorCtaButtons}>
            <button className={styles.heroBtnCyan} onClick={() => navigate('/contact')}>
              Contact Us <FiArrowRight />
            </button>
          </div>
        </div>
      </section>

      {/* 🟦 4. FOOTER */}
      <footer className={styles.footerSection}>
        <div className={styles.footerInner}>
          {/* Brand area left */}
          <div className={styles.footerBrandColumn}>
            <div className={styles.footerBrandLogo} onClick={() => navigate('/')}>
              <img src={logo} alt="SaleSense Logo" className={styles.footerLogoImg} />
              <span>Sailsense AI</span>
            </div>
            <p className={styles.footerBrandText}>
              AI Chat, Voice and Video agents that capture leads, automate conversations and close sales — 24/7.
            </p>
            <p className={styles.footerBrandProductOf}>
              A product of <strong>Provaantech</strong>
            </p>
          </div>

          {/* Brand System center */}
          <div className={styles.footerLinkColumn}>
            <h4 className={styles.footerColHeader}>Brand System</h4>
            <ul className={styles.footerLinksList}>
              <li className={styles.footerLinkItem}>
                <FiMessageCircle style={{ marginRight: '0.5rem' }} /> Sailsense Chatbot
              </li>
              <li className={styles.footerLinkItem}>
                <FiPhone style={{ marginRight: '0.5rem' }} /> ROVIA — Voice AI
              </li>
              <li className={styles.footerLinkItem}>
                <FiVideo style={{ marginRight: '0.5rem' }} /> AIMEE — Video AI
              </li>
              <li className={styles.footerLinkItem}>
                <FiSettings style={{ marginRight: '0.5rem' }} /> Sailsense Platform
              </li>
            </ul>
          </div>

          {/* Industries right */}
          <div className={styles.footerLinkColumn}>
            <h4 className={styles.footerColHeader}>Focus Industry</h4>
            <ul className={styles.footerLinksList}>
              <li className={styles.footerLinkItem}>Automotive Dealerships</li>
            </ul>
          </div>
        </div>

        {/* Bottom row copyright */}
        <div className={styles.footerBottomBar}>
          <div>© 2026 Sailsense AI - Provaantech. All rights reserved.</div>
          <div>Built for high-performance sales teams.</div>
        </div>
      </footer>
    </div>
  );
};

export default SolutionsPage;
